import { Row } from 'antd'
import DocumentItem from 'app/components/Core/Document/Item'
import KCard from 'app/components/UI-Elements/DataDisplay/KCard'
import KSingleCollapse from 'app/components/UI-Elements/DataDisplay/KSingleCollapse'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import * as React from 'react'

import QuotePriceDetailed from './Price/Detailed'
import QuotePriceSummary from './Price/Summary'
interface Props extends React.ComponentProps<typeof KCard> {
  quote: IQuote
}

const QuoteCard: React.FC<Props> = ({ quote, ...others }) => {
  const { tComponent } = ToolBox.useString()

  const translate = (id: string) =>
    tComponent({
      recordType: RecordType.quote,
      id,
      componentType: 'data_display',
      componentName: 'card'
    })

  const Wrapper: React.FC<React.PropsWithChildren> = ({ children }) => (
    <Row gutter={[0, 24]}>
      <KCol render={Boolean(quote?.url)} span={24}>
        <DocumentItem url={quote?.url} title={translate('description')} />
      </KCol>
      <KCol span={24} className="fade-in-slow">
        {children}
      </KCol>
      <If condition={others.children}>
        <KCol span={24}>{others.children}</KCol>
      </If>
    </Row>
  )

  return (
    <KCard title={translate('title')} {...others}>
      <If condition={quote}>
        <KSingleCollapse
          headerCollapsed={
            <Wrapper>
              <QuotePriceSummary member={quote} />
            </Wrapper>
          }
          header={<Wrapper>{<QuotePriceDetailed member={quote} />}</Wrapper>}
          defaultExpanded={quote.discount_price < 0}
        />
      </If>
    </KCard>
  )
}

export default QuoteCard
